// public
import React from 'react';
import PropTypes from 'prop-types';

import { slugify } from '@xingternal/malt-util';
import {
  fallbackFemale,
  fallbackMale,
  fallbackNeutral,
  fallbackCompany,
} from './fallbacks';
import base from './SuperEllipseShell.css';
import { mergeStyles } from '@xingternal/merge-styles';

const getSources = type => {
  switch (type) {
    case 'company':
      return { typeImg: fallbackCompany, typeId: 'profile-company' };
    case 'female-user':
      return { typeImg: fallbackFemale, typeId: 'user-female' };
    case 'male-user':
      return { typeImg: fallbackMale, typeId: 'user-male' };
    case 'neutral-user':
      return { typeImg: fallbackNeutral, typeId: 'user-neutral' };
    default:
      return { typeImg: fallbackNeutral, typeId: 'user-neutral' };
  }
};

const SuperEllipseShell = ({ skin, profileName, src, type, ...props }) => {
  const styles = mergeStyles(base, skin);

  const { typeImg, typeId } = getSources(type);

  const imageSrc = src || typeImg;
  const id = `imageId-${slugify(src || typeId)}`;
  return (
    <div className={styles.superElipse}>
      <svg
        className={styles.superElipse}
        viewBox="0 0 256 256"
        role={profileName}
        {...props}
      >
        <title>{profileName}</title>
        <defs>
          <pattern
            id={id}
            patternUnits="userSpaceOnUse"
            width="100%"
            height="100%"
          >
            <image
              xlinkHref={imageSrc}
              x="0"
              y="0"
              width="100%"
              height="100%"
              alt={profileName}
            />
          </pattern>
        </defs>
        <g fill={`url(#${id})`}>
          <path
            stroke="#F5F5F5"
            className={styles.strokeWidth}
            d="M18.947 18.947C5.627 32.267 1 61.517 1 128s4.626 95.732 17.947 109.053C32.267 250.373 61.517 255 128 255s95.732-4.626 109.053-17.947C250.373 223.733 255 194.483 255 128s-4.626-95.732-17.947-109.053C223.733 5.627 194.483 1 128 1S32.268 5.626 18.947 18.947z"
          />
        </g>
      </svg>
    </div>
  );
};

SuperEllipseShell.propTypes = {
  /** Override or extend the styles applied to the component. skin={profileImage: styles.myHeroClassName} */
  skin: PropTypes.object,
  /** add the profile name */
  profileName: PropTypes.string,
  /** The src attribute for the img element. */
  src: PropTypes.string,
  /** 	Used to render icon inside the Avatar. If there is no src  props will not be used and no img will be rendered by default.
This can be  just a string.
 */
  type: PropTypes.oneOf([
    'female-user',
    'male-user',
    'neutral-user',
    'company',
  ]),
};

export default SuperEllipseShell;
